// extracted by mini-css-extract-plugin
export default {"icon":"src-components-icon-styles-icon-IpNRI","icon-dark":"src-components-icon-styles-icon-dark-yjirg","icon-light":"src-components-icon-styles-icon-light-hKCjk"};